<template>
  <span />
</template>

<script>
export default {
  props: {
    dimensionUnit: {
      type: String,
      default: null
    },
    dimensionValue: {
      type: Number,
      default: null
    },
    value: {
      type: Number,
      default: null
    }
  },
  watch: {
    dimensionUnit() {
      this.changeHandler();
    },
    dimensionValue() {
      this.changeHandler();
    }
  },
  methods: {
    changeHandler() {
      this.$emit(
        "input",
        this.convertDimensionValueToInches(
          this.dimensionValue,
          this.dimensionUnit
        )
      );
    },
    convertDimensionValueToInches(dimensionValue, dimensionUnit) {
      switch (dimensionUnit) {
        case "in":
          return dimensionValue;
        case "ft":
          return dimensionValue * 12;
        case "mm":
          return dimensionValue / 25.4;
        case "m":
          return dimensionValue / 0.0254;
      }
    }
  }
};
</script>
